import React, { createContext, useState, useContext, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const StaffAuthContext = createContext();

export const useStaffAuth = () => {
  const context = useContext(StaffAuthContext);
  if (!context) {
    throw new Error('useStaffAuth must be used within StaffAuthProvider');
  }
  return context;
};

export const StaffAuthProvider = ({ children }) => {
  const [staffUser, setStaffUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch(`${API}/api/staff/auth/health`, {
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        setStaffUser(data.user);
        sessionStorage.setItem('staff_user', JSON.stringify(data.user));
      } else {
        setStaffUser(null);
        sessionStorage.removeItem('staff_user');
      }
    } catch (error) {
      setStaffUser(null);
      sessionStorage.removeItem('staff_user');
    } finally {
      setLoading(false);
    }
  };

  const login = async (user) => {
    // Immediately update context state with user data from login response
    setStaffUser(user);
    sessionStorage.setItem('staff_user', JSON.stringify(user));
  };

  const logout = async () => {
    try {
      await fetch(`${API}/api/staff/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setStaffUser(null);
      sessionStorage.removeItem('staff_user');
      window.location.href = '/staff/login';
    }
  };

  const value = {
    staffUser,
    loading,
    isAuthenticated: !!staffUser,
    isAdmin: staffUser?.role === 'admin',
    isStaff: staffUser?.role === 'staff',
    login,
    logout,
    checkAuth
  };

  return (
    <StaffAuthContext.Provider value={value}>
      {children}
    </StaffAuthContext.Provider>
  );
};
